import React, { useEffect, useState } from "react";
import { AxiosResponse } from "axios";
import { Result, Group } from "../../interface/IcdToIcdRelation";
import { icdToicdRelationAxiosInstance } from "../../Network/icdToicdRelationAxiosInstance";
import { ColumnDef } from "@tanstack/react-table";
import { DataTable } from "shared/DataTable";
import { Button } from "../../components/ui/button";
import Joi from "joi";

const Relationicdtoicd: React.FC = () => {
  const [items, setItems] = useState<{ result: Result[] }>({ result: [] });
  const [searchInput, setSearchInput] = useState<string>("");
  const [filteredItems, setFilteredItems] = useState<Result[]>([]);
  const [firstGroup, setFirstGroup] = useState<Group>({
    icd_codes: [],
    custom_icd_groups: [],
    medical_icd_groups: [],
  });
  const [secondGroup, setSecondGroup] = useState<Group>({
    icd_codes: [],
    custom_icd_groups: [],
    medical_icd_groups: [],
  });

  const [errorId, setErrorId] = useState<number | null>(0);
  const [IdError, setIdError] = useState<string>("");

  const token = localStorage.getItem('token') || "";
  const [editIndex, setEditIndex] = useState<number | null>(null);
  const Erroridschema = Joi.string()
  .allow("")
  .regex(/^\d+$/)
  .messages({
    "string.pattern.base": "Please enter only numbers",
  });
  const fetchItems = async (): Promise<void> => {
    try {
      const response: AxiosResponse<{ success: boolean; result: Result[] }> =
        await icdToicdRelationAxiosInstance.get("geticdrelation");
      setItems({ result: [...response.data.result].sort((a: any, b: any) => b.id - a.id) });

      setFilteredItems(response.data.result); // Initialize filteredItems with all items
    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };

  useEffect(() => {
    fetchItems();
  }, []);

  
  const handleErrorIdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
  
  // check the entry using Joi
    const { error } = Erroridschema.validate(value);
  
    if (error) {
      setIdError(error.message); 
    } else {
      setIdError(""); 
      const inputValue = e.target.value.trim();
      setErrorId(inputValue === "" ? 0: parseInt(inputValue))
     }
  };

  const addItem = async (): Promise<void> => {
    try {
      const newIcdToIcdRelation = {
        first_group: firstGroup,
        second_group: secondGroup,
        error_id: errorId,
        token: token,
      };

      await icdToicdRelationAxiosInstance.post(
        "addicdrelation",
        newIcdToIcdRelation
      );
      fetchItems();
      setFirstGroup({
        icd_codes: [],
        custom_icd_groups: [],
        medical_icd_groups: [],
      });
      setSecondGroup({
        icd_codes: [],
        custom_icd_groups: [],
        medical_icd_groups: [],
      });
      setErrorId(0);

      console.log("New group Added Successfully:", newIcdToIcdRelation);
    } catch (error) {
      console.error("Error adding item:", error);
    }
  };

  const updateItem = async (id: string | number): Promise<void> => {
    try {
      const updatedItem = {
        first_group: firstGroup,
        second_group: secondGroup,
        error_id: errorId,
        id: id,
        token: token,
      };

      await icdToicdRelationAxiosInstance.put(
        `updateicdrelation`,
        updatedItem
      );
      fetchItems();

      setFirstGroup({
        icd_codes: [],
        custom_icd_groups: [],
        medical_icd_groups: [],
      });
      setSecondGroup({
        icd_codes: [],
        custom_icd_groups: [],
        medical_icd_groups: [],
      });
      setErrorId(0);
      setEditIndex(null);

      console.log("Item updated successfully:", updatedItem);
    } catch (error) {
      console.error("Error updating item:", error);
    }
  };

  const removeItem = async (id: string | number): Promise<void> => {
    try {
      await icdToicdRelationAxiosInstance.delete(`deleteicdrelation/${id}`, {
   
       
        data: { token: token },
      });
      console.log(id);
      fetchItems();
   
    } catch (error) {
      console.error("Error removing item:", error);
    }
  };
  {
    /*
  const handleSearchKeyPress = (e: React.KeyboardEvent<HTMLInputElement>): void => {
    if (e.key === 'Enter') {
      performSearch();
    }
  };

  const performSearch = () => {
    if (searchInput.trim() === '') {
      setFilteredItems(items.result);
    } else {
      const searchResult = items.result.filter((item) =>
        item.first_group.icd_codes.some((code) => code.includes(searchInput)) ||
        item.first_group.medical_icd_groups.some((group) => group.includes(searchInput)) ||
        item.second_group.icd_codes.some((code) => code.includes(searchInput)) ||
        item.second_group.medical_icd_groups.some((group) => group.includes(searchInput))
      );
      setFilteredItems(searchResult);
    }
  };

*/
  }


  const resetForm = () => {
    setFirstGroup({
      icd_codes: [],
      custom_icd_groups: [],
      medical_icd_groups: [],
    });
    setSecondGroup({
      icd_codes: [],
      custom_icd_groups: [],
      medical_icd_groups: [],
    });
    setErrorId(0);
    setEditIndex(null);

  };

  const handleEdit =  (item: Result) => {
    setFirstGroup(item.first_group);
    setSecondGroup(item.second_group);
    setErrorId(item.error_id);

    setEditIndex(item.id);
  }
  
  const columns: ColumnDef<Result>[] = [
    {
      accessorKey: "id",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          ID
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },
   
    {
      accessorKey: "first_group",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
FirstGroup
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const FirstGroup = row.getValue("first_group") as string[];
        return Array.isArray(FirstGroup) ? FirstGroup.join(", ") : FirstGroup;
      },
    },
 {
      accessorKey: "second_group",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >SecondGroup
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const SecondGroup = row.getValue("second_group") as string[];
        return Array.isArray(SecondGroup) ? SecondGroup.join(", ") : SecondGroup;
      },
    },
    {
      accessorKey: "error_id",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
 ErrorId
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },
  ];

  return (
    <div className="container" style={{ margin: "30px" }}>
      {/* title */}
      <h5>
      ICD To ICD Relation Screen{" "}
        <span>
          {" "}
          <i className="fa-solid fa-briefcase"></i>{" "}
        </span>{" "}
      </h5>
  
      {/* model */}
      {/* tabIndex="-1" */}
      <div
        className="modal fade"
        id="exampleModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Add Item
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                {" "}
              </button>
            </div>

            <div className=" container d-flex flex-column align-items-center ">
              <div>
                <label className="m-2">First Group :</label>

                {/* Input for icd_codes */}
                <div style={{ marginBottom: "10px" }}>
                  <label className="m-2">ICD Codes:</label>
                  <input
                    type="text"
                    className="form-control"
                    style={{ marginBottom: "10px" }}
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                    value={firstGroup.icd_codes.join(",")}
                    onChange={(e) => {
                      const values = e.target.value
                        .split(",")
                        .map((item) => item.trim());
                      setFirstGroup((prevState) => ({
                        ...prevState,
                        icd_codes: values,
                      }));
                    }}
                  />
                </div>

                {/* Input for custom_icd_groups */}
                <div style={{ marginBottom: "10px" }}>
                  <label className="m-2">Custom ICD Groups:</label>
                  <input
                    type="text"
                    className="form-control"
                    style={{ marginBottom: "10px" }}
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                    value={firstGroup.custom_icd_groups.join(",")}
                    onChange={(e) => {
                      const values = e.target.value
                        .split(",")
                        .map((item) => Number(item.trim()));
                      setFirstGroup((prevState) => ({
                        ...prevState,
                        custom_icd_groups: values,
                      }));
                    }}
                  />
                </div>

                {/* Input for medical_icd_groups */}
                <div style={{ marginBottom: "10px" }}>
                  <label className="m-2">Medical ICD Groups:</label>
                  <input
                    type="text"
                    className="form-control"
                    style={{ marginBottom: "10px" }}
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                    value={firstGroup.medical_icd_groups.join(",")}
                    onChange={(e) => {
                      const values = e.target.value
                        .split(",")
                        .map((item) => item.trim());
                      setFirstGroup((prevState) => ({
                        ...prevState,
                        medical_icd_groups: values,
                      }));
                    }}
                  />
                </div>
              </div>

              <div>
                <label className="m-2">Second Group :</label>

                {/* Input for icd_codes */}
                <div style={{ marginBottom: "10px" }}>
                  <label className="m-2">ICD Codes:</label>
                  <input
                    type="text"
                    className="form-control"
                    style={{ marginBottom: "10px" }}
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                    value={secondGroup.icd_codes.join(",")}
                    onChange={(e) => {
                      const values = e.target.value
                        .split(",")
                        .map((item) => item.trim());
                      setSecondGroup((prevState) => ({
                        ...prevState,
                        icd_codes: values,
                      }));
                    }}
                  />
                </div>

                {/* Input for custom_activity_groups */}
                <div style={{ marginBottom: "10px" }}>
                  <label className="m-2">Custom ICD Groups:</label>
                  <input
                    type="text"
                    className="form-control"
                    style={{ marginBottom: "10px" }}
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                    value={secondGroup.custom_icd_groups.join(",")}
                    onChange={(e) => {
                      const values = e.target.value
                        .split(",")
                        .map((item) => Number(item.trim()));
                      setSecondGroup((prevState) => ({
                        ...prevState,
                        custom_icd_groups: values,
                      }));
                    }}
                  />
                </div>

                {/* Input for medical_icd_groups */}
                <div style={{ marginBottom: "10px" }}>
                  <label className="m-2">Medical ICD Groups:</label>
                  <input
                    type="text"
                    className="form-control"
                    style={{ marginBottom: "10px" }}
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                    value={secondGroup.medical_icd_groups.join(",")}
                    onChange={(e) => {
                      const values = e.target.value
                        .split(",")
                        .map((item) => item.trim());
                      setSecondGroup((prevState) => ({
                        ...prevState,
                        medical_icd_groups: values,
                      }));
                    }}
                  />
                </div>
              </div>
              <div style={{ marginBottom: "10px" }}>

              <label className="m-2 ">Error ID :</label>
              <input
                type="text"
                className="form-control"
                style={{ marginBottom: "10px" }}
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                value={errorId !== null ? errorId.toString() : ""}
                onChange={handleErrorIdChange}
              />
              {IdError && <div style={{ color: "red" }}>{IdError}</div>}

              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={
                  editIndex === null ? addItem : () => updateItem(editIndex)
                }
              >
                {editIndex === null ? "Add Item" : "Update Item"}
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={resetForm}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* table */}
      <DataTable
  columns={columns}
  data={items.result}
  searchColumn="first_group"
  addButtonLabel="Add New Relation" // Custom button text
  modalId="exampleModal" // Custom add modal ID
  showAddButton={true} // Control visibility
  onEdit={handleEdit}
  onDelete={removeItem}
/>
    </div>
  );
};

export default Relationicdtoicd;
